import { Injectable } from '@angular/core';
import { ApiBaseService } from '@core/services/api-base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiConstant } from '@shared/constants/api.constant';
import { UserType } from '@shared-features/enums/user-type.enum';
import { filterNullEntity } from '@shared/utils/filter-null-entity.util';
import { WaitingChargeConfig } from '@shared-features/models/waiting-charge-config.model';
import { UpdateWaitingChargeConfigDto } from '@shared-features/interfaces';

@Injectable({
  providedIn: 'root',
})
export class WaitingChargeConfigApiService {
  constructor(private baseAPI: ApiBaseService) {}

  getConfig(configSource: UserType, entityId: number): Observable<WaitingChargeConfig> {
    const url = configSource === UserType.FLEET
      ? `${ApiConstant.WAITING_CHARGE_CONFIG_FLEET}${entityId}`
      : `${ApiConstant.WAITING_CHARGE_CONFIG_CUSTOMER}${entityId}`;
    return this.baseAPI.get(url).pipe(map((res) => res.data as WaitingChargeConfig));
  }

  updateConfig(
    configSource: UserType,
    entityId: number,
    payload: UpdateWaitingChargeConfigDto
  ): Observable<WaitingChargeConfig> {
    const url = configSource === UserType.FLEET
      ? `${ApiConstant.WAITING_CHARGE_CONFIG_FLEET}${entityId}`
      : `${ApiConstant.WAITING_CHARGE_CONFIG_CUSTOMER}${entityId}`;
    return this.baseAPI.put(url, filterNullEntity(payload)).pipe(map((res) => res.data as WaitingChargeConfig));
  }
}
